import Model, { attr } from '@ember-data/model';

import type { DateRangeInterface, Slack } from 'webapp-types';
import { SnapshotFormat } from 'webapp/enums/enums';

import type { ScheduleUser } from 'webapp/models-custom/schedule';

export const DEFAULT_NOTE =
	'Hey! I’m sharing this dashboard with you. Take a quick look and let me know if you have any questions or ideas for improvement.';

export default class BoardShareRecord extends Model {
	@attr('number') boardId!: number | null;
	@attr('number') loopId!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	recipients!: string[];
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	slackChannels!: Slack.Channels;
	@attr('string', { defaultValue: '' }) subject!: string;
	@attr('string', { defaultValue: DEFAULT_NOTE }) note!: string;
	@attr('number', { defaultValue: SnapshotFormat.JPG }) format!: number;
	@attr('number') createdById!: number;
	@attr('number') created!: number;
	@attr('boolean') includeLink!: boolean;
	@attr('number', { defaultValue: 3 }) scheduleType!: number;
	@attr('number', { defaultValue: 9 }) scheduleHourOfDay!: number | null; // null without a schedule
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	scheduleDayOfWeek!: number[];
	@attr('number', { defaultValue: -1 }) scheduleDayOfMonth!: number | null; // null without a schedule
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	scheduleUser!: ScheduleUser | null;
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	dateRange!: DateRangeInterface.FormulaInterface | Record<string, never>;
	@attr('boolean', { defaultValue: false }) declare includeBgImages: boolean;
}
